import React from 'react'

function Airpod() {
  return (
    <div>
    <br/> <br/>
    <h1>thes is Airpod page</h1>
    </div>
  )
}

export default Airpod